import { useSelectorLogic } from "../selectorHook";
import { Props } from "../types";
import DropDownMarkup from "./markup";

export default function DropDownList(props: Props) {
	const { value, setValueFn: setValue } = useSelectorLogic(props);

	return <DropDownMarkup {...props} onChange={setValue} value={value} />;
}
